export default "__VITE_ASSET__3q1OnEDK__"